import { createContext } from 'react';
import initialCatalogDownloadState from './initialCatalogDownloadState';

const CatalogDownloadContext = createContext(initialCatalogDownloadState);

export default CatalogDownloadContext;
